import { HeartHandshake } from "lucide-react";

import { IgTooltip } from "@intelligems/ig-theme";

interface AgencyIconProps {
  text?: string;
}

export const AgencyIcon = ({ text }: AgencyIconProps) => {
  return (
    <IgTooltip title={text || "Part of Agency"} sx={{ marginTop: "6px" }}>
      <HeartHandshake size={20} />
    </IgTooltip>
  );
};
